import { render, staticRenderFns } from "./addClassBj.vue?vue&type=template&id=15103746&scoped=true"
import script from "./addClassBj.vue?vue&type=script&lang=js"
export * from "./addClassBj.vue?vue&type=script&lang=js"
import style0 from "./addClassBj.vue?vue&type=style&index=0&id=15103746&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15103746",
  null
  
)

export default component.exports